export const enum ShapePropertiesEnum {
    Opacity="opacity",
    Angle="angle",
    Fill="fill",
    StrokeWidthShape="strokeWidthShape",
    Stroke="stroke",
    VisibleText="visibleText",
    TextText="textText",
    LeftText="leftText",
    TopText="topText",
    FontSizeText="fontSizeText",
    FillText="fillText",
    AngleText="angleText",
    VisibleIcon="visibleIcon",
    TypeIconIcon="typeIconIcon",
    LeftIcon="leftIcon",
    TopIcon="topIcon",
    Scaled="scaled",
    FillIcon="fillIcon",
    RotateIcon="rotateIcon",
    Rx="rx",
    Width="width",
    Ry="ry",
    Height="height"
}